import slideBlockMeta from './block.json';
import { slideIcon } from '../icons';
import { getBlockLabelByName } from '@helpers/utils.js';
import edit from './edit';
import save from './save';
import './style.scss';

const { registerBlockType } = wp.blocks;
const { name, ...settings } = slideBlockMeta;

registerBlockType(name, {
  ...settings,
  icon: slideIcon,
  edit,
  save,
  __experimentalLabel: (attributes) =>
    getBlockLabelByName(attributes, settings.title),
});
